import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { TasksQueueState } from '../types'
import featureStateSelector from './featureStateSelector'

export const updateLandingsListCurrentPageSelector = createSelector<ReduxState, TasksQueueState, number>(
  featureStateSelector,
  state => state.updateLandingsTasksPagination.currentPage
)
